import "@theme/turnstile"
 
class NotifyMeForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.button = this.querySelector('button[type="submit"]');
    this.message = this.querySelector(".notify-me-message");

    if (!this.form || !this.button || !this.message) {
      return;
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.form.addEventListener("submit", this.handleSubmit);
  }

  disconnectedCallback() {
    if (this.form && this.handleSubmit) {
      this.form.removeEventListener("submit", this.handleSubmit);
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    this.message.innerHTML = "";
    this.button.disabled = true;
    this.button.classList.add("disabled");

    try {
      const response = await fetch(this.form.action, {
        method: "POST",
        body: new FormData(this.form),
        headers: { Accept: "application/json" },
      });

      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        throw new Error("API Error");
      }
      this.form.innerHTML = this.form.dataset.success;
    } catch (error) {
      if (!window.turnstile){
        console.error("Turnstile did not load, so the verification token could not be sent.", error);
      }
      this.showError();
    } finally {
      if (this.isConnected && this.button) {
        this.button.disabled = false;
        this.button.classList.remove("disabled");
      }
    }
  }

  showError() {
    this.message.innerHTML = `<div class="error">${this.form.dataset.error}</div>`;
  }
}

if (!customElements.get("notify-me-form")) {
  customElements.define("notify-me-form", NotifyMeForm);
}